import React from "react";
import { AppBar, Box, IconButton, Stack, Toolbar, Typography } from "../../../imports/muiImport";
import { useEffect, useState, useSelector, useDispatch } from "../../../imports/generalImport";

import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../../hooks/contexts/AuthContext';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { handleAmount } from '../../../shared/extra';
import { Bell, Menu, Search } from "lucide-react";
import { fetchUserProfile } from "../../../store/userProfile/action";

function MobileNavbar({ toggleDrawer, isPageTitleUpdate, pageTitle }) {
    const [canGoBack, setCanGoBack] = useState(false);
    const userInfoStore = useSelector((state) => state.UserProfile?.allData?.user);
    const userBalanceStore = useSelector((state) => state?.UserProfile?.allData?.wallet);

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();
    const { isLoggedIn } = useAuth();

    React.useEffect(() => {
        if (isLoggedIn) {
            if (!userInfoStore || !userBalanceStore) {
                dispatch(fetchUserProfile());
            }
        }
    }, [userBalanceStore, userInfoStore]);

    useEffect(() => {
        // Check if the user has browser history
        if (window.history.length > 1) {
            setCanGoBack(true);
        }
    }, []);


    const handleBackClick = () => {
        if (canGoBack) {
            navigate(-1); // Navigate back if there's history
        } else {
            navigate('/'); // Redirect to home if there's no history
        }
    };


    function capitalize(word) {
        return word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase();
    }




    return (
        <AppBar
            position="fixed"
            sx={{
                width: '100%',
                boxShadow: 0,
                borderRadius: 0,
                backgroundColor: 'white.main',
            }}
        >
            <Toolbar
                disableGutters
                sx={{
                    px: 2,
                    py: 1,
                    minHeight: "56px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                {/* Left Icon: Back or Menu */}
                <Box>
                    {isPageTitleUpdate ? (
                        <IconButton
                            size="medium"
                            edge="start"
                            aria-label="back"
                            onClick={handleBackClick}
                            sx={{
                                color: "primaryDark.main",
                                p: 1.2,
                            }}
                        >
                            <ArrowBackIosIcon sx={{ fontSize: 22 }} />
                        </IconButton>
                    ) : (
                        <IconButton
                            size="medium"
                            edge="start"
                            aria-label="menu"
                            onClick={toggleDrawer(true)}
                            sx={{
                                color: "primaryDark.main",
                                p: 1.2,
                                mr: 1,
                            }}
                        >
                            <Menu
                                style={{
                                    fontSize: 26,
                                    stroke: "#002865",
                                    strokeWidth: 1.5,
                                }}
                            />
                        </IconButton>
                    )}
                </Box>

                {/* Center Title/User Info */}
                <Box sx={{ flexGrow: 1, ml: 1 }}>
                    {isPageTitleUpdate ? (
                        <Typography
                            variant="h6"
                            sx={{
                                color: "primaryDark.main",
                                fontWeight: 600,
                                fontSize: "1rem",
                                textTransform: "capitalize",
                                textAlign: "left",
                            }}
                        >
                            {capitalize(pageTitle)}
                        </Typography>
                    ) : isLoggedIn ? (
                        userInfoStore ? (
                            <Stack spacing={0.2}>
                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: "primaryDark.main",
                                        fontWeight: 500,
                                        fontSize: "0.975rem",
                                        textTransform: "capitalize",
                                    }}
                                >
                                    {userInfoStore?.name}
                                </Typography>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        color: "dark.main",
                                        fontSize: "0.75rem",
                                        lineHeight: 1.4,
                                    }}
                                >
                                    Wallet: ₹{userBalanceStore?.balance > 1 ? handleAmount(userBalanceStore?.balance) : "0.00"}
                                </Typography>
                            </Stack>
                        ) : (
                            <CircularProgress sx={{ color: "primary.main" }} size={16} thickness={4} />
                        )
                    ) : (
                        <Typography
                            variant="h6"
                            sx={{
                                color: "primaryDark.main",
                                fontWeight: 500,
                                fontSize: "1rem",
                                textTransform: "capitalize",
                            }}
                        >
                            Guest
                        </Typography>
                    )}
                </Box>

                {(isLoggedIn && !isPageTitleUpdate) && (
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                        }}
                    >
                        {!['/', '/search']?.includes(location?.pathname) && (<IconButton
                            size="medium"
                            sx={{ p: 1 }}
                            aria-label="search"
                        >
                            <NavLink to="/search">
                                <Search
                                    style={{
                                        fontSize: 26,
                                        stroke: "#002865",
                                        strokeWidth: 1.5,
                                    }}
                                />
                            </NavLink>
                        </IconButton>)}

                        {/* <IconButton
              size="medium"
              sx={{ p: 1 }}
              aria-label="notifications"
            >
              <NavLink to="/profile/notifications">
                <Bell
                  style={{
                    fontSize: 26,
                    stroke: "#002865",
                    strokeWidth: 1.5,
                  }}
                />
              </NavLink>
            </IconButton> */}
                    </Box>
                )}
            </Toolbar>

        </AppBar>
    );
}

export default MobileNavbar
